import {ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PreviewModalOptions, PreviewModalService} from '@services/preview-modal.service';
import {ModalComponent} from '@components/modal/modal.component';
import {Observable} from 'rxjs/internal/Observable';
import {tap} from 'rxjs/operators';

@Component({
    selector: 'app-preview-modal',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './preview-modal.component.html',
})
export class PreviewModalComponent implements OnInit, OnDestroy {

    public show$: Observable<PreviewModalOptions>;

    @ViewChild(ModalComponent) private modal: ModalComponent;

    constructor(
        private filesPreviewService: PreviewModalService,
    ) {
    }

    ngOnInit() {
        this.show$ = this.filesPreviewService.show$.pipe(
            tap(() => {
                this.modal.open();
            })
        );
    }

    ngOnDestroy(): void {

    }
}
